import { render, staticRenderFns } from "./remove-cards.vue?vue&type=template&id=a7b66728&"
import script from "./remove-cards.vue?vue&type=script&lang=js&"
export * from "./remove-cards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports